import { render, staticRenderFns } from "./AdminChangePassword.vue?vue&type=template&id=14a4e800&"
import script from "./AdminChangePassword.vue?vue&type=script&lang=js&"
export * from "./AdminChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports